import Button from '@glass/shared/components/Button/Button';

const ButtonAction = Button;

ButtonAction.defaultProps = {
  ...Button.defaultProps,
  size: 'small',
  color: 'inherit',
  variant: 'text',
};

export default ButtonAction;
